<mat-form-field floatLabel="never" [ngClass]="classField()">
  <mat-select placeholder="..." [formControl]="control()">
    <mat-option [value]="'Purchase'"><span translate>Purchase</span></mat-option>
    <mat-option [value]="'Owned'"><span translate>Owned</span></mat-option>
    <mat-option [value]="'Sell'"><span translate>Sell</span></mat-option>
    <mat-option [value]="'Sold'"><span translate>Sold</span></mat-option>
  </mat-select>
</mat-form-field>
@if (ownershipVerified()) {
  <mat-icon style="font-size: 16px;" [matTooltip]="'Ownership verified' | translate">verified_user</mat-icon>
}